import {Paper, withWidth, Typography, Grid} from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import React, {useState} from 'react';
import {
  FlexibleXYPlot,
  XAxis,
  YAxis,
  VerticalBarSeries,
  VerticalGridLines,
  HorizontalGridLines,
  VerticalBarSeriesPoint,
  Hint,
} from 'react-vis';
import {TotalRecordsChartDetailsPayload} from 'Enrollment/models/TotalRecordsChartDetailsPayload';
import {WithWidthProps} from '@material-ui/core/withWidth';
import './EnrollmentsBarChart.sass';

type EnrollmentTotalRecordsChartProps = {
  totalRecordsChartDetails: TotalRecordsChartDetailsPayload[];
} & WithWidthProps;

const EnrollmentTotalRecordsChart = (props: EnrollmentTotalRecordsChartProps) => {
  const [hintText, setHintText] = useState<VerticalBarSeriesPoint | null>(null);
  const graphData: any[] = props.totalRecordsChartDetails!.map(d => ({
    x: `${d.monthName}-${d.year!.toString().substring(2, 4)}`,
    y: d.count,
  }));
  const handleSeriesMouseOver = (e: VerticalBarSeriesPoint) => {
    setHintText(e);
  }
  const handleSeriesMouseOut = () => {
    setHintText(null);
  };
    const BarSeries =  VerticalBarSeries;

    const formatLabelCount = (labelValue: any) => {
      if (labelValue >= 1000 && labelValue < 1000000) {
        return (labelValue / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
      }
      else if(labelValue >= 1000000)
        return (labelValue / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';

      return labelValue;
    };

    return (
      <Paper className="enrollments-bar-chart">
        <div className="enrollments-bar-chart__header">
          <Grid container spacing={2}>
            <Grid item xs={12} md={8}>
              <h3 id="enrollments-line-chart-total-records-title" className="enrollments-bar-chart__header-title">Total Records</h3>
            </Grid>
          </Grid>
        </div>
        <div className="enrollments-bar-chart__container">         
        <FlexibleXYPlot xType="ordinal" height={300} margin={{left:50,bottom: 80}}stackBy="y">
          <VerticalGridLines />
          <HorizontalGridLines />
          <XAxis tickLabelAngle={-90} />
          <YAxis tickFormat={(v: number) => formatLabelCount(v)} />
          <BarSeries data={graphData}
            onValueMouseOver={e => handleSeriesMouseOver(e)}
            onValueMouseOut={handleSeriesMouseOut}/>
          {hintText && (
            <Hint xType="ordinal" yType="literal" align={{vertical: 'bottom', horizontal: 'left'}} value={{ x: hintText.x}}>
              <Tooltip title="Hint" className="enrollments-bar-chart__container-tooltip">
                <Typography> {hintText.y} </Typography>
              </Tooltip>
            </Hint>
          )}
        
        </FlexibleXYPlot>
      </div> 
    </Paper>
    );
};

export default withWidth()(EnrollmentTotalRecordsChart);
